var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 153,
    viewBox: "0 0 222 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#card-success_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.633,
    y: 9,
    width: 188.732,
    height: 115.472,
    rx: 16,
    fill: "url(#card-success_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.138,
    y: 9.505,
    width: 187.723,
    height: 114.462,
    rx: 15.495,
    stroke: "#FF8484",
    strokeOpacity: 0.6,
    strokeWidth: 1.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "card-success_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 9,
    width: 190,
    height: 116
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.138,
    y: 9.505,
    width: 187.723,
    height: 114.462,
    rx: 15.495,
    fill: "#FC5C5C",
    stroke: "#FF8484",
    strokeWidth: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#card-success_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-success_svg__paint1_linear)",
    d: "M16.633 35.628h188.732v23.601H16.633z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#card-success_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.999,
    cy: 124.127,
    r: 18.873,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.998 108.398c-8.681 0-15.728 7.046-15.728 15.728 0 8.681 7.047 15.727 15.728 15.727 8.682 0 15.728-7.046 15.728-15.727 0-8.682-7.046-15.728-15.728-15.728zm-3.145 23.591l-7.864-7.863 2.217-2.218 5.647 5.631 11.937-11.938 2.218 2.234-14.155 14.154z",
    fill: "#40C26E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-success_svg__paint0_linear",
    x1: 205.365,
    y1: 9,
    x2: 72.176,
    y2: 83.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-success_svg__paint1_linear",
    x1: 16.633,
    y1: 35.628,
    x2: 205.421,
    y2: 58.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF765C"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "card-success_svg__filter0_d",
    x: 0.479,
    y: 0.923,
    width: 221.04,
    height: 147.779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.077
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.077
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "card-success_svg__filter1_d",
    x: 85.126,
    y: 99.253,
    width: 53.746,
    height: 53.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default SvgCardSuccess;